 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import BACKEDBIRDSFRONT_1 from '@/components/backed/birdsfront_1'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/title'
 import CONTENTS from '@/components/contents'
 import BOOKS from '@/components/books'
 import TOT from '@/components/tot'
 import INTRO from '@/components/intro'
 import IMAGE from '@/components/image'
 import CHAPTER1 from '@/components/chapter1'
 import CHAPTER2 from '@/components/chapter2'
 import CHAPTER3 from '@/components/chapter3'
 import CHAPTER4 from '@/components/chapter4'
 import CHAPTER5 from '@/components/chapter5'
 import CHAPTER6 from '@/components/chapter6'
 import CHAPTER7 from '@/components/chapter7'
 import CHAPTER8 from '@/components/chapter8'
 import CHAPTER9 from '@/components/chapter9'
 import CHAPTER10 from '@/components/chapter10'
 import CHAPTER11 from '@/components/chapter11'
 import CHAPTER12 from '@/components/chapter12'
 import LOVE_2 from '@/components/love_2'
 import COPYRIGHT from '@/components/copyright'
 import BACKEDBACKAD_1 from '@/components/backed/backad_1'
 import BACKEDPHILOSO_1 from '@/components/backed/philoso_1'
 import BACKEDORIMAD_1 from '@/components/backed/ORIM-ad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/books",
 			"name" : "books",
 			"component" : BOOKS
 		},
 		{
 			"path" : "/tot",
 			"name" : "tot",
 			"component" : TOT
 		},
 		{
 			"path" : "/intro",
 			"name" : "intro",
 			"component" : INTRO
 		},
 		{
 			"path" : "/image",
 			"name" : "image",
 			"component" : IMAGE
 		},
 		{
 			"path" : "/chapter1",
 			"name" : "chapter1",
 			"component" : CHAPTER1
 		},
 		{
 			"path" : "/chapter2",
 			"name" : "chapter2",
 			"component" : CHAPTER2
 		},
 		{
 			"path" : "/chapter3",
 			"name" : "chapter3",
 			"component" : CHAPTER3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js